<script lang="ts">
  import { AppBar, Button, Menu, ListItem } from 'svelte-materialify';
  import { user } from '../store';
  import { AuthService } from '../modules';
  import { link } from 'svelte-spa-router';

  export let title = '';
  export let titleLink = '';
  export let subtitle = '';

  async function logout() {
    await AuthService.logout();
    window.location.reload();
  }
</script>

<div on:click>
  <AppBar fixed>
    <div class="app-icon" slot="icon">
      <a href="/" use:link>DailyReports</a>
    </div>
    <span slot="title">
      <div class="d-flex align-center">
        {#if titleLink}
          <a class="title-link text-h6 mr-6" href={titleLink} use:link>{title}</a>
        {:else}
          <h6 class="text-h6 mr-6">{title}</h6>
        {/if}
        <span class="text-subtitle-1">{subtitle}</span>
      </div>
    </span>
    <Menu right>
      <div slot="activator">
        <Button class="user-menu" depressed>
          {$user.username}
        </Button>
      </div>
      <ListItem on:click={logout}>Logout</ListItem>
    </Menu>
  </AppBar>
</div>

<style lang="scss">
  .app-icon {
    width: 256px;
  }

  .title-link {
    color: inherit;
  }
</style>
